import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../api';
import './types';
import { ContractorObjectGroups, ContractorObjectItem, ContractorObjectType } from './types';

const contractorObject = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getContractorObjectDetail: builder.query<ContractorObjectItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ContractorObject/${data.id}/details`,
      }),
    }),
    changeContractorObject: builder.mutation<void, ContractorObjectItem>({
      query: (data) => ({
        url: `/v1/ContractorObject/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createContractorObject: builder.mutation<void, ContractorObjectItem>({
      query: (data) => ({
        url: '/v1/ContractorObject',
        method: 'POST',
        body: data,
      }),
    }),
    deleteContractorObject: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ContractorObject/${data.id}`,
        method: 'DELETE',
      }),
    }),
    getContractorObjectTypes: builder.query<ContractorObjectType[], void>({
      query: () => ({
        url: '/v1/ContractorObject/types',
      }),
    }),
    getContractorObjectLocations: builder.query<ContractorObjectType[], void>({
      query: () => ({
        url: '/v1/ContractorObject/locations',
      }),
    }),
    getContractorObjectGroups: builder.query<
      ContractorObjectGroups[],
      { contractorId: number | string; isRequiredId?: number }
    >({
      query: (data) => ({
        url: `/v1/ContractorObject/${data.contractorId}/groups`,
        params: { isRequiredId: data.isRequiredId },
      }),
    }),
  }),
});

export const {
  useGetContractorObjectDetailQuery,
  useLazyGetContractorObjectDetailQuery,
  useChangeContractorObjectMutation,
  useCreateContractorObjectMutation,
  useDeleteContractorObjectMutation,
  useGetContractorObjectGroupsQuery,
  useGetContractorObjectTypesQuery,
  useLazyGetContractorObjectGroupsQuery,
  useLazyGetContractorObjectTypesQuery,
  useGetContractorObjectLocationsQuery,
} = contractorObject;
